<div class="main">
  <aku-header class="header"></aku-header>
  <!-- I would have called this main or something -->
  <div class="router-holder">
    <router-outlet></router-outlet>
  </div>
</div>
